import tinymce from './components/TinymceVue'

export default tinymce
export { tinymce }


//////////////////
// WEBPACK FOOTER
// ./~/vue-tinymce-editor/src/index.js
// module id = 978
// module chunks = 0